// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oxanium:wght@200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* --themecolor: #711818; */
  --themecolor: #2d699b;
  --themecolor2: #fdffc1;
  --themehover: #d83d10;
  --bgclr: #0e0e0c;
  --bgclr1: #000000;
  --cardbg: #161616;
  --sideclr: #070707;
  --borderclr: #eeefbb8a;
  --modalclr: #151515;
  --blackclr: #000;
  --bodyclr: #eee;
  --whtclr: #fff;
}
body {
  margin: 0;
  /* font-family: "Oxanium", sans-serif !important; */
  font-family: "Rubik", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background: var(--bgclr1) !important; */
  background: var(--bodyclr) !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.requestFont{
  font-size: 13px !important;
  margin-top: 10px !important;
  margin-bottom: 0 !important;
}
.themebtn {
  /* background: url('./assets/images/btn.png') !important;
  background-size: 100% 100% !important; 
  background-repeat: no-repeat !important; */
  background-color: var(--themecolor) !important;
  border: none !important;
  color: var(--whtclr) !important;
  /* min-width: 100px; */
}
.themebtn:hover {
  /* background: url('./assets/images/btnhover.png') !important;
  background-size: 100% 100% !important; 
  background-repeat: no-repeat !important; */
  background-color: var(--themehover) !important;
  border: none !important;
  color: var(--whtclr) !important;
  /* box-shadow:4px 1px 13px -7px var(--themecolor) !important; */
}
.customcontainer {
  max-width: 95% !important;
}

.modalstyled .reactstyled__control {
  background: none !important;
  min-height: 5vh !important;
  max-height: 5vh !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
  outline: 0;
  border-bottom: 0.2vh dashed var(--borderclr);
}
.modalstyled .reactstyled__value-container {
  padding: 1vh;
}
.error_msg {
  color: red;
  font-size: 13px;
}
.modalstyled .reactstyled__placeholder {
  margin-left: 2%;
  margin-right: 2%;
  font-size: 2vh;
  color: var(--borderclr);
}
.modalstyled .reactstyled__indicator-separator {
  display: none;
}
.modalstyled .reactstyled__indicator {
  padding: 1vh;
}
.modalstyled .reactstyled__indicator svg {
  width: 3vh;
  height: 3vh;
}
.modalstyled .reactstyled__menu-list {
  background: #141414;
}
.modalstyled .reactstyled__option {
  color: var(--themecolor2);
  font-size: 2vh;
  padding: 1vh 1.5vh;
  background: none !important;
}
.modalstyled .reactstyled__option--is-focused {
  background: var(--themecolor) !important;
  color: var(--themecolor2) !important;
}
.modalstyled .reactstyled__single-value {
  color: var(--themecolor2);
  font-size: 2vh;
}

::-webkit-scrollbar {
  width: 0.2vw;
  height: 0.3vh;
  background-color: #aaa; /* or add it to the track */
}
::-webkit-scrollbar-track {
  background: #000;
}
::-webkit-scrollbar-thumb {
  background: var(--themecolor);
}

.allbtn {
  border: unset;
  background: #2d699b !important;
  border: 0.2vh solid #2d699b !important;
  font-size: 1.9vh !important;
  border-radius: 0.4vh;
  font-weight: 500 !important;
  color: #fff !important;
  padding: 5px 10px !important;
}
.allbtn:hover {
  background: #d83d10;
  border: 0.2vh solid #d83d10;
  /* color: #fff !important; */
  opacity: 0.9;
}
.rdt_Pagination {
  padding-right: 0.8vh !important;
  padding-left: 0.8vh !important;
  color: var(--blackclr) !important;
  font-size: 1.8vh !important;
  min-height: 7vh !important;
  border-top-width: 0.3vh !important;
}
.rdt_Pagination select {
  height: 2vh !important;
  padding-left: 0.6vh !important;
  padding-right: 2vh !important;
}
.react-datatables .rdt_TableRow {
  min-height: 5.5vh !important;
}
.react-datatables .rdt_TableRow:not(:last-of-type) {
  border-bottom-width: 0.2vh;
}
.rdt_TableCol_Sortable span {
  padding: 1vh !important;
}
.rdt_Pagination button {
  height: 4vh;
  width: 3.8vh;
  padding: 0.6vh;
}
.rdt_Pagination span {
  margin: 0 2vh !important;
}
.rdt_Pagination svg {
  width: 2.6vh !important;
  height: 2.6vh !important;
}
.react-datatables .rdt_TableCol {
  font-size: 1.7vh;
  padding-left: 0.4vh;
  padding-right: 0.4vh;
}
.react-datatables .rdt_TableCell {
  font-size: 1.6vh;
  padding-left: 0.4vh;
  padding-right: 0.4vh;
}
.formlabel {
  /* color: var(--blackclr); */
  color: var(--themecolor);
  font-weight: 500;
  /* font-size: 1.8vh; */
  font-size: 2.2vh;
  margin-bottom: 0.4vh;
}
.formcontrol {
  display: block;
  width: 100%;
  padding: 0.5vh 0.8vh;
  font-size: 2vh;
  font-weight: 400;
  line-height: 1.5;
}
.formcontrol:focus-visible {
  outline: unset;
}
.w_100 {
  width: 100px;
  max-width: 100px;
}
.unread {
  height: 10px;
  width: 10px;
  display: inline-block;
  border-radius: 50%;
  background-color: green;
}
.activeSelect .css-1nmdiq5-menu{
  font-size: 2vh !important;
}
.tablebox .form-control {
    margin-bottom: 20px;
    margin-left: auto;
    width: fit-content;
}
.rdtCounters{
  color: black;
  display: flex !important;
}
.form-control {
    border-color: var(--bordercolor);
    color: var(--black);
    font-size: 15px;
    padding: 7px 12px;
}

.cardbox {
    background-color: var(--white);
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 #00000024;
    padding: 20px;
}
/* new changes sakthi start 12-11-24 */

/* new css */
body {
  background-color: #eee !important;
}

.footer {
  display: none;
}

.sidebar {
  min-height: 100vh !important;
}
.borders {
  border: 1px solid #80808057;
  border-radius: 6px;
}
.imgset {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.sidebar .sidebar-brand-wrapper,
.sidebar,
.navbar .navbar-brand-wrapper,
.navbar {
  /* background: linear-gradient(81.33deg,#1f2421 7.09%,#546158 173.02%) !important; */
  /* background: #060803 !important; */
  /* background: #2f669814 !important; */
  background: #000 !important;
}

.sidebar .nav .nav-item.nav-category .nav-link,
.sidebar .nav .nav-item .nav-link,
.sidebar .nav.sub-menu .nav-item .nav-link,
.navbar .navbar-menu-wrapper .navbar-toggler {
  color: #fff;
  font-weight: 500;
}

.content-wrapper {
  background: #eee !important;
}

.sidebar .nav .nav-item .menu-icon {
  background: #d83d10 !important;
}

.sidebar
  .nav:not(.sub-menu)
  > .nav-item:hover:not(.nav-category):not(.account-dropdown)
  > .nav-link {
  /* background: #fff !important; */
  background: #2d699b !important;
  color: #fff !important;
}

.sidebar
  .nav:not(.sub-menu)
  > .nav-item:hover:not(.nav-category):not(.account-dropdown)
  > .nav-link
  .menu-title {
  color: #fff;
}

.sidebar .nav .nav-item {
  margin-top: 8px;
}

.sidebar .nav .menu-items:nth-child(5n + 3) .nav-link .menu-icon i {
  color: #8bed0f;
}

.sidebar .nav .nav-item.active > .nav-link {
  background: #2d699b !important;
}

.card {
  /* background: #162019; */
  background: #fff;
  border: 1px solid #ffffff26;
  /* box-shadow: 0 3px 10px #ffffff0f; */
  /* background: #fff; */
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  border-radius: 6px;
}

.table,
.text-muted,
th.sortable {
  /* color: #fff !important; */
  color: black !important;
}

.blkclrs {
  color: #000 !important;
}

.footer {
  background: #fff !important;
}

.footer a {
  color: #2d699b !important;
}

.card .card-title {
  color: #2d699b !important;
  /* color: #499de9 !important; */
}

.form-control::placeholder {
  color: gray !important;
}

.form-group label {
  color: #000000de !important;
}

form h4 {
  color: #d83d10;
}

.form-group p {
  color: #2d699b;
}

.form-control {
  background: #ffffff0d !important;
  color: #000 !important;
  font-size: 2vh !important;
}

.form-control:disabled,
.form-control[readonly] {
  /* color: #c7c7c7 !important; */
  color: #696969 !important;
}

.sidebar .nav.sub-menu .nav-item .nav-link:hover {
  color: #3cdb6a;
}

.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini img {
  max-width: 45px;
  margin-top: 4px !important;
}

select option {
  background: #353f3a !important;
}

.icon.icon-box-success {
  color: #00d25b !important;
  /* background: #00d25b !important; */
}

.auth .brand-logo {
  text-align: center;
}

/* new end */

.pos {
  position: relative;
  z-index: 3;
}

.wrapss {
  display: flex;
  /* flex-wrap: wrap; */
  overflow: auto;
  gap: 4px;
  background-color: #fff;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  margin: 0px 8px 6px 8px;
  padding: 4px 4px;
}

.widthset {
  width: 90px;
  min-width: 90px;
  background: #00000017;
  /* margin: auto; */
  text-align: center;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #98bfded6;
}

.closeicon {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 1px;
  right: 1px;
  color: #000;
  cursor: pointer;
}

.chatimage {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.uploadlogos {
  width: 70px;
  height: 70px;
  object-fit: contain;
}

.textbreak {
  word-wrap: break-word;
  font-size: 2vh;
}

.personimg {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

.chatname {
  color: #000;
  font-size: 2vh;
}

.box_left {
  width: 500px;
  /* width: fit-content; */
  min-width: 300px;
  background-color: #ffe7bb;
  padding: 10px;
  border-radius: 4px;
  color: #000;
  position: relative;
  z-index: 2;
}

.box_right {
  width: 500px;
  /* width: fit-content; */
  min-width: 300px;
  background-color: #2d699b;
  padding: 10px;
  border-radius: 4px;
  color: #fff;
  margin-left: auto;
  position: relative;
  z-index: 2;
}

.chattext_box {
  padding: 14px 8px;
  height: 420px;
  min-height: 420px;
  overflow-y: auto;
  max-height: 100vh;
}
.chattext_boxHeight{
  height: 40px;
}

.chattext_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.chattext_box::-webkit-scrollbar {
  width: 9px;
  background-color: #f5f5f5;
}

.chattext_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #2d699b;
}

.textend {
  text-align: end;
  font-size: 2vh;
}

.fw-600 {
  font-weight: 600;
}

.timepos {
  position: absolute;
  bottom: 2px;
  right: 7px;
  font-size: 10px;
  font-weight: 500;
}

.playpos {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: 28px;
  transform: translate(-50%, -50%);
}

.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini img {
  width: calc(90px - 50px);
}

.navbar .navbar-brand-wrapper .navbar-brand.brand-logo-mini img {
  width: calc(90px - 50px);
}

.sidebar .sidebar-brand-wrapper .sidebar-brand img {
  width: calc(244px - 100px) !important;
  margin-top: 16px !important;
}

.userlistss tbody tr td {
  padding: 12px 12px;
}
.textleft {
  text-align: left;
  font-size: 2vh;
}
.textend {
  text-align: end;
}
.textorg {
  color: #e30d00;
}
.textgray {
  color: #c9c6c6;
}
.form-control:focus {
  color: #000 !important;
  border: 1px solid rgb(47 102 152 / 57%) !important;
}

select.form-control {
  border-top: 1px solid #000;
}

/* .asrt-page-length select{
    background: transparent !important;
    border: 1px solid #413e47 !important;
} */
select {
  cursor: pointer;
}

select option {
  cursor: pointer;
}

input[type="search"]::-webkit-search-cancel-button {
  cursor: pointer !important;
  color: #fff !important;
}

.asrt-pagination li {
  cursor: pointer;
}

.passwordinput .form-control {
  background-color: #191c24;
}

.passwordinput .btn-outline-primary {
  color: #2d699b;
  border-color: #494a51;
  padding: 10px 10px;
}

.passwordinput .btn-outline-primary:hover {
  background-color: transparent !important;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus {
  box-shadow: unset !important;
}

/* .footer a{
    color: #886abe !important;
} */
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fff !important;
}

.asrt-page-length .input-group-addon {
  background: unset !important;
}

.asrt-page-length select {
  color: #2d699b !important;
}

.input-group-prepend span {
  color: #000 !important;
}

.asrt-table-foot {
  margin-top: 2%;
}

.page-item.disabled .page-link {
  color: #2d699b !important;
  pointer-events: none;
  cursor: auto;
  background-color: #fff0 !important;
  border-color: #2d699b !important;
}

.page-item.disabled .page-link:hover {
  background-color: #2d699b !important;
  color: #fff !important;
  border-color: #2d699b !important;
  border: 1px solid #2d699b;
}

.as-react-table .pagination li:hover a {
  background-color: #2d699b !important;
  color: #fff !important;
}

.page-link {
  background-color: #00000000 !important;
  border: 1px solid #2d699b;
}
.page-link:hover input {
  color: #fff !important;
}
.page-link input {
  background: unset !important;
  color: #2d699b !important;
}

.table thead th {
  line-height: 21px;
}

.allbtnlogout {
  background: red;
  border: 1px solid red;
  padding: 6px 14px;
  color: #fff;
  border-radius: 6px;
}

.allbtnlogout:hover {
  background: transparent;
  border: 1px solid red;
  color: red;
}

.allbtns {
  padding: 8px 16px !important;
}

.css-yt9ioa-option {
  color: black !important;
  /* background-color: #886abe !important; */
}

.css-1n7v3ny-option {
  /* background-color: #886abe !important; */
}

.NFT.IDT {
  width: 580px !important;
  max-width: 580px !important;
  word-wrap: break-word !important;
}

.NFT.IDT p {
  line-height: normal;
  font-weight: 400;
}

.css-6c09z3-option {
  color: #000 !important;
}

.css-1gj9k8-option {
  background-color: unset !important;
  color: #000 !important;
}

.css-zjsb6u-option {
  background-color: #886abe !important;
}

.css-1n7v3ny-option {
  background-color: unset !important;
  color: black !important;
  /* background-color: transparent !important;
   color: black !important; */
}

.css-1pahdxg-control:hover {
  border-color: white !important;
}

.css-9gakcf-option {
  background-color: #886abe !important;
}

/* .css-9gakcf-option {
    background-color: transparent !important;
    color: black !important;
} */

.icon.icon-box-success {
  background: #00d25b1c !important;
}

.icon .icon-item {
  color: #fff;
}

.passwordEyePosition{
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}
.confirmpasswordEyePosition{
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}
.kycFont{
  font-size: 2vh;
}
.ReactModal__Overlay {
  background-color: #00000091 !important;
}

.ReactModal__Content {
  border: 1px solid #808080a8 !important;
  background: rgb(11 12 15) !important;
  border-radius: 16px !important;
}

.ReactModal__Content h2 {
  color: rgb(136 106 190) !important;
}

.closebtn {
  position: absolute;
  right: 8px;
  top: 4px;
  font-size: 19px;
  font-weight: 500;
}
.profileHover:hover{
  background-color: rgb(45 105 155) !important;
}
.closebtn:hover {
  color: #886abe;
}

.table-responsive {
  padding-bottom: 2%;
  overflow-x: auto !important;
}

/* .asrt-table-body {
    overflow: auto;
    padding-bottom: 2%;
} */
.table-responsive::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.table-responsive::-webkit-scrollbar {
  width: 8px !important;
  height: 9px !important;
  background-color: #f5f5f5;
}

.table-responsive::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #886abe;
}

.faq .as-react-table {
  padding-bottom: 2%;
  overflow-x: auto !important;
}

.faq .as-react-table::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.faq .as-react-table::-webkit-scrollbar {
  width: 8px !important;
  height: 9px !important;
  background-color: #f5f5f5;
}

.faq .as-react-table::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #886abe;
}

.sidebar .nav .nav-item .nav-link i.menu-arrow:before {
  display: none;
}

.dash-token {
  color: #886abe !important;
}

.editservice {
  font-size: 15px;
}

.sidebar .nav.sub-menu .nav-item .nav-link {
  white-space: normal;
  line-height: 20px;
}

/* th.sortable {
    color: #886abe !important;
    font-weight: 600 !important;
} */

@media only screen and (max-width: 767px) {
  .table-responsive::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
    background-color: #f5f5f5;
  }

  .faq .as-react-table::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
    background-color: #f5f5f5;
  }

  .table-responsive {
    padding-bottom: 8%;
  }

  .faq .as-react-table {
    padding-bottom: 8%;
  }

  .pagination {
    justify-content: unset !important;
  }

  .pagination li {
    font-size: 11px !important;
    margin-top: 10px;
  }

  .table_filter input {
    margin-top: 14px;
  }

  .asrt-page-length .input-group-text {
    font-size: 11px;
  }

  .asrt-page-length select.form-control {
    padding: 0.4375rem 0.45rem !important;
    width: 53px !important;
    font-size: 12px !important;
  }

  .asrt-table-head .text-right {
    text-align: left !important;
  }

  .asrt-table-foot > div:first-child {
    font-size: 12px;
    margin-top: 6px;
  }
}

.navbar.loginnavbar {
  left: 0px !important;
}

.btn-primary:not(.btn-light):not(.btn-secondary):focus,
.custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):focus:after,
.btn-primary:not(.btn-light):not(.btn-secondary):active,
.custom-file
  .custom-file-label:not(.btn-light):not(.btn-secondary):active:after {
  background: #886abe !important;
  border-color: #886abe !important;
  color: #fff !important;
}

.referralpages .btnsec {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.referralpages .add_btnsec {
  margin-left: 15px;
  margin-top: 10px;
}

.referralpages .allbtn {
  width: 100px;
}

@media only screen and (max-width: 767px) {
  .referralpages .add_btnsec {
    margin-left: 12px;
  }

  .referralpages .btnsec {
    margin-bottom: 15px;
  }

  .box_left,
  .box_right {
    width: 350px;
    min-width: 350px;
  }
}

@media screen and (min-width: 360px) and (max-width: 575px) {
  .box_left,
  .box_right {
    width: 250px;
    min-width: 250px;
  }
}

@media screen and (min-width: 320px) and (max-width: 359px) {
  .box_left,
  .box_right {
    width: 200px;
    min-width: 200px;
  }
}

/* start of hariharan css */

.kyc_tab_wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.kyc_tab_wrapper_buttons {
  border: none;
  outline: none;
  background: #8080806e;
 padding: 5px 10px;
  border-radius: 3px;
  font-size: 1.9vh;
}

.kyc_tab_wrapper_buttons.active {
  border: none;
  outline: none;
  background: #2d699b;
  /* padding: 10px 20px; */
  border-radius: 3px;
  color: #fff;
}

.kyc_form_card {
  /* margin-top: 20px; */
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #8080804f;
}

.kyc_form_card_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.kyc_form_card_title {
  color: #2d699b;
  margin-bottom: 0px;
  font-size: 2.2vh;
}

.kyc_form_card_blue_button {
  background: #2d699b;
  border: 1px solid #2d699b;
  font-weight: 500;
  color: #fff;
  padding: 5px 10px;
  font-size: 2vh;
  border-radius: 0.375rem;
  display: flex;
  gap: 6px;
  align-items: center;
}

.kyc_form_card_blue_button:hover {
  background: #2d6a9be3;
}

.kyc_form_wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  gap: 15px;
}

.kyc_form_select_wrapper {
  min-width: 100%;
  width: 100%;
  max-width: 100%;
}

.kyc_form_body_label {
  color: #000000ba;
  font-weight: 450;
  font-size: 2vh;
}

.kyc_form_body_input {
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  /* min-width: 250px;
    width: 250px;
    max-width: 250px; */
}

.kyc_form_card_footer {
  margin-top: 10px;
}

.kyc_form_card_footer_p {
  color: #cc0c0c;
  font-size: 2vh;
  margin-bottom: 5px;
}

.kyc_form_card_footer_content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kyc_form_card_footer_content p {
  color: #000;
  margin-bottom: 0px;
  font-size: 2vh;
}
.select_input_tag{
  font-size: 2vh;
}
.kyc_form_card_delete_button {
  background: #e11414eb;
  border: 1px solid #e11414eb;
  font-weight: 500;
  color: #fff;
  padding: 5px 5px;
  border-radius: 0.375rem;
  display: flex;
  gap: 6px;
  font-size: 14px;
  align-items: center;
  /* margin-top: 10px; */
  /* min-height: 38px;
  height: 38px;
  max-height: 38px; */
}

.kyc_form_card_delete_button:hover {
  background: rgba(255, 0, 0, 0.774);
}

.kyc_form_card_options {
  margin-top: 15px;
  /* border: 1px solid #8080804f;
    padding: 5px;
    border-radius: 3px; */
}

.kyc_form_card_options_p {
  color: #d83d10;
  margin-bottom: 0px;
  font-weight: 500;
  font-size: 2.2vh;
}

.kyc_form_card_options_header {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.kyc_form_card_options_add {
  background: #d83d10;
  border: none;
  font-weight: 500;
  color: #fff;
  padding: 5px 16px;
  border-radius: 0.375rem;
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 2vh;
}

.kyc_form_card_options_add:hover {
  background: #d83b10e3;
  border: none;
  font-weight: 500;
  color: #fff;
  padding: 5px 10px;
  border-radius: 0.375rem;
  display: flex;
  gap: 6px;
  align-items: center;
}

.kyc_div_width {
  min-width: 250px;
  width: 250px;
  max-width: 250px;
}

.kyc_ph_input .PhoneInput {
  width: 100% !important;
}

.kyc_ph_input {
  /* border-color: hsl(0, 0%, 80%); */
  border-radius: 4px;
  border: 1px solid hsl(0, 0%, 80%);
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: 5px;
  z-index: 0;
}
.kyc_ph_input .PhoneInput input {
  border: none !important;
  outline: none !important;
  color: #000 !important;
  font-weight: normal;
  font-size: 2vh !important;
}

.kyc_div_width .css-1jqq78o-placeholder{
  font-size: 2vh !important;
  height: 30px !important;
}

.kyc_div_width .css-13cymwt-control{
  height: 32px !important;
}
.select_input_tag__control{
  height: 32px !important; 
}
.css-t3ipsp-control{
  min-height: 0px !important;
}
.kyc_div_width .css-1nmdiq5-menu{
  min-height: 0px !important;
}

.css-13cymwt-control{
  min-height: 0 !important;
}
 .css-1wy0on6{
  height: 30px !important;
}
.css-1dimb5e-singleValue{
  font-size: 2vh !important;
}
.PhoneInputCountryIcon {
  color: #000 !important;
}

/* media */

@media (min-width: 400px) {
  .kyc_form_select_wrapper {
    min-width: 250px;
    width: 250px;
    max-width: 250px;
  }

  .kyc_form_body_input {
    min-width: 250px;
    width: 250px;
    max-width: 250px;
  }
}

/* end of hariharan css */

/* start sakthi css 09-08-24 */

.gap_zero {
  gap: 0px;
}
.man_grp_sng_gap {
  gap: 7px !important;
}
.mid_frm_lft {
  margin-left: 19px;
}
.four_frm_lft {
  margin-left: 7px;
}
.egt_frm_lft {
  margin-left: 42px;
}
.lnc_frm_lft {
  margin-left: 48px;
}
.frpm_frm_lft {
  margin-left: 36px;
}
.egtpm_frm_lft {
  margin-left: 47px;
}

.adm_inpt_wrp {
  border: 1px solid rgba(34, 34, 34, 0.32);
  height: 40px;
  border-radius: 10px;
}
.adm_inpt_wrp input {
  border: none;
  outline: none;
  background: none;
  padding: 0px !important;
  min-width: 100% !important;
  width: 100% !important;
  max-width: 100% !important;
}
.adm_inpt_wrp i {
  cursor: pointer;
}

.mangra_overflow_align {
  width: 100%;
  /* overflow-x: auto; */
  margin-top: 20px;
  padding-bottom: 20px;
  color: #2d699b;
}
.mangra_whole_ttl {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #232222;
  margin-bottom: 20px;
}
.manualgra_xaxis_txt {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 25px;
}
.manualgra_xaxis_txt {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
}
.manual_graph_single {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
  margin-top: 5px;
  cursor: pointer;
}
.manual_graph_single .single_square {
  height: 20px;
  width: 12px;
  min-width: 12px;
  background-color: lightgrey;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.manual_graph_single .single_square .timing_div {
  width: 25%;
  background-color: #2d699b;
  height: 20px;
  max-height: 20px;
}
.manual_graph_single .single_square .test111 {
  width: 25%;
  background-color: lightgrey !important;
  height: 20px;
  max-height: 20px;
}
.manualgra_yaxis_txt {
  margin: 0;
  font-size: 13px;
  color: #2d699b;
  font-weight: 700;
  margin-right: 10px;
  min-width: 30px;
}
.cmn_ttl_aligns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 20px;
}
.cmn_ttl_aligns_new.cmn_ttl_aligns {
  justify-content: flex-start !important;
}
.title_percent_ttl {
  width: 45%;
}
.title_percent_ttl_new.title_percent_ttl {
  min-width: 250px;
}
.checkbox_title,
.daysslct_ttl p {
  margin: 0;
  font-weight: 500;
  font-size: 17px;
}
.whole_check_datepick {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  margin-top: 5px;
  padding-bottom: 10px;
}
.daysslct_ttl {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
}
.show_days_div {
  display: flex;
  justify-content: flex-start;
  gap: 9px;
  align-items: center;
  width: 40%;
  font-weight: 700;
  font-size: 18px;
  min-width: 17px;
  max-width: 17px;
  margin-bottom: 0px;
  margin-right: 15px;
}

.show_days_div .form-check {
  margin-top: 0px;
}
.dateselect_dtls .rdt {
  position: relative !important;
}
.dateselect_dtls .rdt input {
  width: 100px;
  height: 30px;
}
.dateselect_dtls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}
.dateselect_dtls .rdt input {
  font-size: 11px;
  padding: 5px 2px;
}
.dateselect_dtls .rdtPicker {
  width: 140px;
}
.rdtOpen .rdtPicker {
  width: 140px;
  min-width: 140px;
}
.days_new_widh p {
  width: 100px;
}
.days_new_widh p:last-child {
  width: 27px !important;
}
.hider_txt {
  opacity: 0;
}
.day_width_45 {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  justify-content: flex-start;

  min-width: 45%;
}
.linecheck_aligned {
  display: flex;
  justify-content: flex-start;
  gap: 9px;
  align-items: center;
  width: 40%;
}
.linecheck_aligned.linecheck_aligned_new {
  max-width: 17px;
  margin-right: 15px;
}

.show_days_div .form-check-input.is-valid,
.was-validated .form-check-input:valid {
  /* border: 2px solid #6c6a81 !important; */
  height: 16px;
  width: 16px;
}

.show_days_div .form-check-input.is-valid,
.was-validated .form-check-input:valid:active {
  box-shadow: none !important;
}

.show_days_div input[type="checkbox" i]:focus-visible {
  outline-offset: 0px !important;
}
.show_days_div .form-check-input:active,
.show_days_div .form-check-input:focus-visible {
  /* filter: brightness(100%) !important; */
  /* border: 2px solid #a71d24 !important; */
}
.show_days_div .form-check-input.is-valid:checked,
.was-validated .form-check-input:valid:checked {
  /* background-color: #fff; */
  /* border: 2px solid #a71d24 !important; */
}
.show_days_div .form-check-input:checked[type="checkbox"] {
  /* background: url("../images/redtick.png"); */
  /* background-position: center; */
  /* background-size: contain; */
  /* background-repeat: no-repeat; */
}
.show_days_div .form-check-label {
  color: #232222 !important;
  font-size: 13px;
  margin: 0;
  font-weight: 500;
}
.order_trashed_ic {
  height: 27px;
  cursor: pointer;
}
.triple_copybtns {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
}
.mangra_addtime.blue_btn {
  width: 100px;
  margin-top: 20px;
  padding: 5px;
}
.mangra_addtime.mangra_addtime_new.blue_btn {
  width: unset;
  margin-top: 20px;
  padding: 5px 20px;
  margin-right: 15px;
  white-space: nowrap;
}

.custom_label {
  color: #2d699b;
  font-weight: 500;
}

.from_to_timePick {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
}

.from_to_timePick.times {
  gap: 85px;
}

.customDatePicker .rdt input {
  font-size: 11px;
  padding: 5px 10px;
  width: 100px;
  height: 30px;
  border: 0.5px solid #2322224d;
  background: linear-gradient(0deg, #ffffff, #ffffff),
    linear-gradient(0deg, rgba(35, 34, 34, 0.3), rgba(35, 34, 34, 0.3));
  border-radius: 10px;
}

.edit_admin .form-check {
  border: none !important;
  margin: 0px;
  display: flex;
  align-items: center;
}

.edit_admin .form-check-input {
  margin-top: 0px;
  height: 16px;
  width: 16px;
}

.edit_admin .form-check .form-check-label {
  display: inline;
  line-height: 0px;
  padding-left: 0.625rem;
  font-size: 0.875rem;
}

/* .profile_details .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.profile_details .upload-btn-wrapper .btn {
  border: 1px solid gray;
  color: #000000de;
  background-color: white;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 10px;
}

.moduleTitle-txt {
  color: var(--themecolor);
}

.profile_details .upload-btn-wrapper input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
} */

.profile_details .profileImg {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
}

.profile_details .uploadImg {
  display: flex;
  align-items: center;
  gap: 20px;
}

.UserProfile {
  display: flex;
  align-items: center;
  gap: 10px;
}
.UserProfile .profileImg {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
}

.card .card-title {
  color: #2d699b !important;
  font-size: 2vh;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .mangra_addtime.mangra_addtime_new.blue_btn {
    margin-right: 6px !important;
  }
}
@media (width < 992px) {
  .mangra_overflow_align.mangra_overflow_align_new {
    overflow-x: auto;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .tet_lefvc.checkbox_title.text-center.checkbox_title_new {
    text-align: center !important;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .mangra_addtime.mangra_addtime_new.blue_btn {
    margin-right: 6px !important;
  }
}
@media (width < 576px) {
  .mangra_overflow_align {
    overflow-x: auto;
  }
  .title_percent_ttl {
    width: 100%;
  }
  .checkbox_title {
    min-width: 200px;
  }
  .checkbox_title_new.checkbox_title {
    min-width: 300px !important;
    /* text-align: center; */
  }
  .daysslct_ttl {
    min-width: 200px;
  }
  .day_width_45 {
    min-width: 200px !important;
  }
  .linecheck_aligned {
    min-width: 200px;
  }
  .linecheck_aligned_new.linecheck_aligned {
    min-width: unset !important;
  }
}

@media (max-width: 480px) {
  .show_days_div {
    margin-right: 0px;
  }
}

@media (max-width: 767px) {
  .title_percent_ttl {
    width: 100% !important;
  }
}

/* new changes sakthi end 12-11-24 */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;EACT,mDAAmD;EACnD,2CAA2C;EAC3C,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE;;4CAE0C;EAC1C,8CAA8C;EAC9C,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE;;4CAE0C;EAC1C,8CAA8C;EAC9C,uBAAuB;EACvB,+BAA+B;EAC/B,+DAA+D;AACjE;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAE,2BAA2B;AACrD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;IACI,mBAAmB;IACnB,iBAAiB;IAEjB,kBAAkB;AACtB;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;AACjB;AACA,sCAAsC;;AAEtC,YAAY;AACZ;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,oFAAoF;EACpF,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,iCAAiC;EACjC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;;;EAGE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,YAAY;;AAEZ;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,QAAQ;EACR,sBAAsB;EACtB,uCAAuC;EACvC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;GAGG;AACH;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;GAEG;AACH;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB;6BAC2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;GAGG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;GAGG;AACH;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;EAKE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;CACtB,iBAAiB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB;;uBAEqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB;;qBAEmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB;;yBAEuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;CACC;EACC,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;;AAEA,UAAU;;AAEV;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;;AAEzB,8BAA8B;;AAE9B;EACE,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;;EAE3B,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;EAC1C,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;AACA;;EAEE,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;;EAEE,4BAA4B;EAC5B,0CAA0C;AAC5C;AACA;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B;uEACqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,oCAAoC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Oxanium:wght@200..800&display=swap\");\n\n:root {\n  /* --themecolor: #711818; */\n  --themecolor: #2d699b;\n  --themecolor2: #fdffc1;\n  --themehover: #d83d10;\n  --bgclr: #0e0e0c;\n  --bgclr1: #000000;\n  --cardbg: #161616;\n  --sideclr: #070707;\n  --borderclr: #eeefbb8a;\n  --modalclr: #151515;\n  --blackclr: #000;\n  --bodyclr: #eee;\n  --whtclr: #fff;\n}\nbody {\n  margin: 0;\n  /* font-family: \"Oxanium\", sans-serif !important; */\n  font-family: \"Rubik\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* background: var(--bgclr1) !important; */\n  background: var(--bodyclr) !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.requestFont{\n  font-size: 13px !important;\n  margin-top: 10px !important;\n  margin-bottom: 0 !important;\n}\n.themebtn {\n  /* background: url('./assets/images/btn.png') !important;\n  background-size: 100% 100% !important; \n  background-repeat: no-repeat !important; */\n  background-color: var(--themecolor) !important;\n  border: none !important;\n  color: var(--whtclr) !important;\n  /* min-width: 100px; */\n}\n.themebtn:hover {\n  /* background: url('./assets/images/btnhover.png') !important;\n  background-size: 100% 100% !important; \n  background-repeat: no-repeat !important; */\n  background-color: var(--themehover) !important;\n  border: none !important;\n  color: var(--whtclr) !important;\n  /* box-shadow:4px 1px 13px -7px var(--themecolor) !important; */\n}\n.customcontainer {\n  max-width: 95% !important;\n}\n\n.modalstyled .reactstyled__control {\n  background: none !important;\n  min-height: 5vh !important;\n  max-height: 5vh !important;\n  border-radius: 0;\n  border: none;\n  box-shadow: none;\n  outline: 0;\n  border-bottom: 0.2vh dashed var(--borderclr);\n}\n.modalstyled .reactstyled__value-container {\n  padding: 1vh;\n}\n.error_msg {\n  color: red;\n  font-size: 13px;\n}\n.modalstyled .reactstyled__placeholder {\n  margin-left: 2%;\n  margin-right: 2%;\n  font-size: 2vh;\n  color: var(--borderclr);\n}\n.modalstyled .reactstyled__indicator-separator {\n  display: none;\n}\n.modalstyled .reactstyled__indicator {\n  padding: 1vh;\n}\n.modalstyled .reactstyled__indicator svg {\n  width: 3vh;\n  height: 3vh;\n}\n.modalstyled .reactstyled__menu-list {\n  background: #141414;\n}\n.modalstyled .reactstyled__option {\n  color: var(--themecolor2);\n  font-size: 2vh;\n  padding: 1vh 1.5vh;\n  background: none !important;\n}\n.modalstyled .reactstyled__option--is-focused {\n  background: var(--themecolor) !important;\n  color: var(--themecolor2) !important;\n}\n.modalstyled .reactstyled__single-value {\n  color: var(--themecolor2);\n  font-size: 2vh;\n}\n\n::-webkit-scrollbar {\n  width: 0.2vw;\n  height: 0.3vh;\n  background-color: #aaa; /* or add it to the track */\n}\n::-webkit-scrollbar-track {\n  background: #000;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--themecolor);\n}\n\n.allbtn {\n  border: unset;\n  background: #2d699b !important;\n  border: 0.2vh solid #2d699b !important;\n  font-size: 1.9vh !important;\n  border-radius: 0.4vh;\n  font-weight: 500 !important;\n  color: #fff !important;\n  padding: 5px 10px !important;\n}\n.allbtn:hover {\n  background: #d83d10;\n  border: 0.2vh solid #d83d10;\n  /* color: #fff !important; */\n  opacity: 0.9;\n}\n.rdt_Pagination {\n  padding-right: 0.8vh !important;\n  padding-left: 0.8vh !important;\n  color: var(--blackclr) !important;\n  font-size: 1.8vh !important;\n  min-height: 7vh !important;\n  border-top-width: 0.3vh !important;\n}\n.rdt_Pagination select {\n  height: 2vh !important;\n  padding-left: 0.6vh !important;\n  padding-right: 2vh !important;\n}\n.react-datatables .rdt_TableRow {\n  min-height: 5.5vh !important;\n}\n.react-datatables .rdt_TableRow:not(:last-of-type) {\n  border-bottom-width: 0.2vh;\n}\n.rdt_TableCol_Sortable span {\n  padding: 1vh !important;\n}\n.rdt_Pagination button {\n  height: 4vh;\n  width: 3.8vh;\n  padding: 0.6vh;\n}\n.rdt_Pagination span {\n  margin: 0 2vh !important;\n}\n.rdt_Pagination svg {\n  width: 2.6vh !important;\n  height: 2.6vh !important;\n}\n.react-datatables .rdt_TableCol {\n  font-size: 1.7vh;\n  padding-left: 0.4vh;\n  padding-right: 0.4vh;\n}\n.react-datatables .rdt_TableCell {\n  font-size: 1.6vh;\n  padding-left: 0.4vh;\n  padding-right: 0.4vh;\n}\n.formlabel {\n  /* color: var(--blackclr); */\n  color: var(--themecolor);\n  font-weight: 500;\n  /* font-size: 1.8vh; */\n  font-size: 2.2vh;\n  margin-bottom: 0.4vh;\n}\n.formcontrol {\n  display: block;\n  width: 100%;\n  padding: 0.5vh 0.8vh;\n  font-size: 2vh;\n  font-weight: 400;\n  line-height: 1.5;\n}\n.formcontrol:focus-visible {\n  outline: unset;\n}\n.w_100 {\n  width: 100px;\n  max-width: 100px;\n}\n.unread {\n  height: 10px;\n  width: 10px;\n  display: inline-block;\n  border-radius: 50%;\n  background-color: green;\n}\n.activeSelect .css-1nmdiq5-menu{\n  font-size: 2vh !important;\n}\n.tablebox .form-control {\n    margin-bottom: 20px;\n    margin-left: auto;\n    width: -webkit-fit-content;\n    width: fit-content;\n}\n.rdtCounters{\n  color: black;\n  display: flex !important;\n}\n.form-control {\n    border-color: var(--bordercolor);\n    color: var(--black);\n    font-size: 15px;\n    padding: 7px 12px;\n}\n\n.cardbox {\n    background-color: var(--white);\n    border-radius: 6px;\n    box-shadow: 0 1px 4px 0 #00000024;\n    padding: 20px;\n}\n/* new changes sakthi start 12-11-24 */\n\n/* new css */\nbody {\n  background-color: #eee !important;\n}\n\n.footer {\n  display: none;\n}\n\n.sidebar {\n  min-height: 100vh !important;\n}\n.borders {\n  border: 1px solid #80808057;\n  border-radius: 6px;\n}\n.imgset {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n}\n\n.sidebar .sidebar-brand-wrapper,\n.sidebar,\n.navbar .navbar-brand-wrapper,\n.navbar {\n  /* background: linear-gradient(81.33deg,#1f2421 7.09%,#546158 173.02%) !important; */\n  /* background: #060803 !important; */\n  /* background: #2f669814 !important; */\n  background: #000 !important;\n}\n\n.sidebar .nav .nav-item.nav-category .nav-link,\n.sidebar .nav .nav-item .nav-link,\n.sidebar .nav.sub-menu .nav-item .nav-link,\n.navbar .navbar-menu-wrapper .navbar-toggler {\n  color: #fff;\n  font-weight: 500;\n}\n\n.content-wrapper {\n  background: #eee !important;\n}\n\n.sidebar .nav .nav-item .menu-icon {\n  background: #d83d10 !important;\n}\n\n.sidebar\n  .nav:not(.sub-menu)\n  > .nav-item:hover:not(.nav-category):not(.account-dropdown)\n  > .nav-link {\n  /* background: #fff !important; */\n  background: #2d699b !important;\n  color: #fff !important;\n}\n\n.sidebar\n  .nav:not(.sub-menu)\n  > .nav-item:hover:not(.nav-category):not(.account-dropdown)\n  > .nav-link\n  .menu-title {\n  color: #fff;\n}\n\n.sidebar .nav .nav-item {\n  margin-top: 8px;\n}\n\n.sidebar .nav .menu-items:nth-child(5n + 3) .nav-link .menu-icon i {\n  color: #8bed0f;\n}\n\n.sidebar .nav .nav-item.active > .nav-link {\n  background: #2d699b !important;\n}\n\n.card {\n  /* background: #162019; */\n  background: #fff;\n  border: 1px solid #ffffff26;\n  /* box-shadow: 0 3px 10px #ffffff0f; */\n  /* background: #fff; */\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n  border-radius: 6px;\n}\n\n.table,\n.text-muted,\nth.sortable {\n  /* color: #fff !important; */\n  color: black !important;\n}\n\n.blkclrs {\n  color: #000 !important;\n}\n\n.footer {\n  background: #fff !important;\n}\n\n.footer a {\n  color: #2d699b !important;\n}\n\n.card .card-title {\n  color: #2d699b !important;\n  /* color: #499de9 !important; */\n}\n\n.form-control::placeholder {\n  color: gray !important;\n}\n\n.form-group label {\n  color: #000000de !important;\n}\n\nform h4 {\n  color: #d83d10;\n}\n\n.form-group p {\n  color: #2d699b;\n}\n\n.form-control {\n  background: #ffffff0d !important;\n  color: #000 !important;\n  font-size: 2vh !important;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n  /* color: #c7c7c7 !important; */\n  color: #696969 !important;\n}\n\n.sidebar .nav.sub-menu .nav-item .nav-link:hover {\n  color: #3cdb6a;\n}\n\n.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini img {\n  max-width: 45px;\n  margin-top: 4px !important;\n}\n\nselect option {\n  background: #353f3a !important;\n}\n\n.icon.icon-box-success {\n  color: #00d25b !important;\n  /* background: #00d25b !important; */\n}\n\n.auth .brand-logo {\n  text-align: center;\n}\n\n/* new end */\n\n.pos {\n  position: relative;\n  z-index: 3;\n}\n\n.wrapss {\n  display: flex;\n  /* flex-wrap: wrap; */\n  overflow: auto;\n  gap: 4px;\n  background-color: #fff;\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n  margin: 0px 8px 6px 8px;\n  padding: 4px 4px;\n}\n\n.widthset {\n  width: 90px;\n  min-width: 90px;\n  background: #00000017;\n  /* margin: auto; */\n  text-align: center;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #98bfded6;\n}\n\n.closeicon {\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  top: 1px;\n  right: 1px;\n  color: #000;\n  cursor: pointer;\n}\n\n.chatimage {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n}\n\n.uploadlogos {\n  width: 70px;\n  height: 70px;\n  object-fit: contain;\n}\n\n.textbreak {\n  word-wrap: break-word;\n  font-size: 2vh;\n}\n\n.personimg {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n}\n\n.chatname {\n  color: #000;\n  font-size: 2vh;\n}\n\n.box_left {\n  width: 500px;\n  /* width: fit-content; */\n  min-width: 300px;\n  background-color: #ffe7bb;\n  padding: 10px;\n  border-radius: 4px;\n  color: #000;\n  position: relative;\n  z-index: 2;\n}\n\n.box_right {\n  width: 500px;\n  /* width: fit-content; */\n  min-width: 300px;\n  background-color: #2d699b;\n  padding: 10px;\n  border-radius: 4px;\n  color: #fff;\n  margin-left: auto;\n  position: relative;\n  z-index: 2;\n}\n\n.chattext_box {\n  padding: 14px 8px;\n  height: 420px;\n  min-height: 420px;\n  overflow-y: auto;\n  max-height: 100vh;\n}\n.chattext_boxHeight{\n  height: 40px;\n}\n\n.chattext_box::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.chattext_box::-webkit-scrollbar {\n  width: 9px;\n  background-color: #f5f5f5;\n}\n\n.chattext_box::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #2d699b;\n}\n\n.textend {\n  text-align: end;\n  font-size: 2vh;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.timepos {\n  position: absolute;\n  bottom: 2px;\n  right: 7px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.playpos {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  font-size: 28px;\n  transform: translate(-50%, -50%);\n}\n\n.sidebar .sidebar-brand-wrapper .sidebar-brand.brand-logo-mini img {\n  width: calc(90px - 50px);\n}\n\n.navbar .navbar-brand-wrapper .navbar-brand.brand-logo-mini img {\n  width: calc(90px - 50px);\n}\n\n.sidebar .sidebar-brand-wrapper .sidebar-brand img {\n  width: calc(244px - 100px) !important;\n  margin-top: 16px !important;\n}\n\n.userlistss tbody tr td {\n  padding: 12px 12px;\n}\n.textleft {\n  text-align: left;\n  font-size: 2vh;\n}\n.textend {\n  text-align: end;\n}\n.textorg {\n  color: #e30d00;\n}\n.textgray {\n  color: #c9c6c6;\n}\n.form-control:focus {\n  color: #000 !important;\n  border: 1px solid rgb(47 102 152 / 57%) !important;\n}\n\nselect.form-control {\n  border-top: 1px solid #000;\n}\n\n/* .asrt-page-length select{\n    background: transparent !important;\n    border: 1px solid #413e47 !important;\n} */\nselect {\n  cursor: pointer;\n}\n\nselect option {\n  cursor: pointer;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  cursor: pointer !important;\n  color: #fff !important;\n}\n\n.asrt-pagination li {\n  cursor: pointer;\n}\n\n.passwordinput .form-control {\n  background-color: #191c24;\n}\n\n.passwordinput .btn-outline-primary {\n  color: #2d699b;\n  border-color: #494a51;\n  padding: 10px 10px;\n}\n\n.passwordinput .btn-outline-primary:hover {\n  background-color: transparent !important;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus {\n  box-shadow: unset !important;\n}\n\n/* .footer a{\n    color: #886abe !important;\n} */\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #fff !important;\n}\n\n.asrt-page-length .input-group-addon {\n  background: unset !important;\n}\n\n.asrt-page-length select {\n  color: #2d699b !important;\n}\n\n.input-group-prepend span {\n  color: #000 !important;\n}\n\n.asrt-table-foot {\n  margin-top: 2%;\n}\n\n.page-item.disabled .page-link {\n  color: #2d699b !important;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff0 !important;\n  border-color: #2d699b !important;\n}\n\n.page-item.disabled .page-link:hover {\n  background-color: #2d699b !important;\n  color: #fff !important;\n  border-color: #2d699b !important;\n  border: 1px solid #2d699b;\n}\n\n.as-react-table .pagination li:hover a {\n  background-color: #2d699b !important;\n  color: #fff !important;\n}\n\n.page-link {\n  background-color: #00000000 !important;\n  border: 1px solid #2d699b;\n}\n.page-link:hover input {\n  color: #fff !important;\n}\n.page-link input {\n  background: unset !important;\n  color: #2d699b !important;\n}\n\n.table thead th {\n  line-height: 21px;\n}\n\n.allbtnlogout {\n  background: red;\n  border: 1px solid red;\n  padding: 6px 14px;\n  color: #fff;\n  border-radius: 6px;\n}\n\n.allbtnlogout:hover {\n  background: transparent;\n  border: 1px solid red;\n  color: red;\n}\n\n.allbtns {\n  padding: 8px 16px !important;\n}\n\n.css-yt9ioa-option {\n  color: black !important;\n  /* background-color: #886abe !important; */\n}\n\n.css-1n7v3ny-option {\n  /* background-color: #886abe !important; */\n}\n\n.NFT.IDT {\n  width: 580px !important;\n  max-width: 580px !important;\n  word-wrap: break-word !important;\n}\n\n.NFT.IDT p {\n  line-height: normal;\n  font-weight: 400;\n}\n\n.css-6c09z3-option {\n  color: #000 !important;\n}\n\n.css-1gj9k8-option {\n  background-color: unset !important;\n  color: #000 !important;\n}\n\n.css-zjsb6u-option {\n  background-color: #886abe !important;\n}\n\n.css-1n7v3ny-option {\n  background-color: unset !important;\n  color: black !important;\n  /* background-color: transparent !important;\n   color: black !important; */\n}\n\n.css-1pahdxg-control:hover {\n  border-color: white !important;\n}\n\n.css-9gakcf-option {\n  background-color: #886abe !important;\n}\n\n/* .css-9gakcf-option {\n    background-color: transparent !important;\n    color: black !important;\n} */\n\n.icon.icon-box-success {\n  background: #00d25b1c !important;\n}\n\n.icon .icon-item {\n  color: #fff;\n}\n\n.passwordEyePosition{\n  position: absolute;\n  top: 0px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n.confirmpasswordEyePosition{\n  position: absolute;\n  top: 0px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n.kycFont{\n  font-size: 2vh;\n}\n.ReactModal__Overlay {\n  background-color: #00000091 !important;\n}\n\n.ReactModal__Content {\n  border: 1px solid #808080a8 !important;\n  background: rgb(11 12 15) !important;\n  border-radius: 16px !important;\n}\n\n.ReactModal__Content h2 {\n  color: rgb(136 106 190) !important;\n}\n\n.closebtn {\n  position: absolute;\n  right: 8px;\n  top: 4px;\n  font-size: 19px;\n  font-weight: 500;\n}\n.profileHover:hover{\n  background-color: rgb(45 105 155) !important;\n}\n.closebtn:hover {\n  color: #886abe;\n}\n\n.table-responsive {\n  padding-bottom: 2%;\n  overflow-x: auto !important;\n}\n\n/* .asrt-table-body {\n    overflow: auto;\n    padding-bottom: 2%;\n} */\n.table-responsive::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n\n.table-responsive::-webkit-scrollbar {\n  width: 8px !important;\n  height: 9px !important;\n  background-color: #f5f5f5;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #886abe;\n}\n\n.faq .as-react-table {\n  padding-bottom: 2%;\n  overflow-x: auto !important;\n}\n\n.faq .as-react-table::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n\n.faq .as-react-table::-webkit-scrollbar {\n  width: 8px !important;\n  height: 9px !important;\n  background-color: #f5f5f5;\n}\n\n.faq .as-react-table::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #886abe;\n}\n\n.sidebar .nav .nav-item .nav-link i.menu-arrow:before {\n  display: none;\n}\n\n.dash-token {\n  color: #886abe !important;\n}\n\n.editservice {\n  font-size: 15px;\n}\n\n.sidebar .nav.sub-menu .nav-item .nav-link {\n  white-space: normal;\n  line-height: 20px;\n}\n\n/* th.sortable {\n    color: #886abe !important;\n    font-weight: 600 !important;\n} */\n\n@media only screen and (max-width: 767px) {\n  .table-responsive::-webkit-scrollbar {\n    width: 6px !important;\n    height: 6px !important;\n    background-color: #f5f5f5;\n  }\n\n  .faq .as-react-table::-webkit-scrollbar {\n    width: 6px !important;\n    height: 6px !important;\n    background-color: #f5f5f5;\n  }\n\n  .table-responsive {\n    padding-bottom: 8%;\n  }\n\n  .faq .as-react-table {\n    padding-bottom: 8%;\n  }\n\n  .pagination {\n    justify-content: unset !important;\n  }\n\n  .pagination li {\n    font-size: 11px !important;\n    margin-top: 10px;\n  }\n\n  .table_filter input {\n    margin-top: 14px;\n  }\n\n  .asrt-page-length .input-group-text {\n    font-size: 11px;\n  }\n\n  .asrt-page-length select.form-control {\n    padding: 0.4375rem 0.45rem !important;\n    width: 53px !important;\n    font-size: 12px !important;\n  }\n\n  .asrt-table-head .text-right {\n    text-align: left !important;\n  }\n\n  .asrt-table-foot > div:first-child {\n    font-size: 12px;\n    margin-top: 6px;\n  }\n}\n\n.navbar.loginnavbar {\n  left: 0px !important;\n}\n\n.btn-primary:not(.btn-light):not(.btn-secondary):focus,\n.custom-file .custom-file-label:not(.btn-light):not(.btn-secondary):focus:after,\n.btn-primary:not(.btn-light):not(.btn-secondary):active,\n.custom-file\n  .custom-file-label:not(.btn-light):not(.btn-secondary):active:after {\n  background: #886abe !important;\n  border-color: #886abe !important;\n  color: #fff !important;\n}\n\n.referralpages .btnsec {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.referralpages .add_btnsec {\n  margin-left: 15px;\n  margin-top: 10px;\n}\n\n.referralpages .allbtn {\n  width: 100px;\n}\n\n@media only screen and (max-width: 767px) {\n  .referralpages .add_btnsec {\n    margin-left: 12px;\n  }\n\n  .referralpages .btnsec {\n    margin-bottom: 15px;\n  }\n\n  .box_left,\n  .box_right {\n    width: 350px;\n    min-width: 350px;\n  }\n}\n\n@media screen and (min-width: 360px) and (max-width: 575px) {\n  .box_left,\n  .box_right {\n    width: 250px;\n    min-width: 250px;\n  }\n}\n\n@media screen and (min-width: 320px) and (max-width: 359px) {\n  .box_left,\n  .box_right {\n    width: 200px;\n    min-width: 200px;\n  }\n}\n\n/* start of hariharan css */\n\n.kyc_tab_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.kyc_tab_wrapper_buttons {\n  border: none;\n  outline: none;\n  background: #8080806e;\n padding: 5px 10px;\n  border-radius: 3px;\n  font-size: 1.9vh;\n}\n\n.kyc_tab_wrapper_buttons.active {\n  border: none;\n  outline: none;\n  background: #2d699b;\n  /* padding: 10px 20px; */\n  border-radius: 3px;\n  color: #fff;\n}\n\n.kyc_form_card {\n  /* margin-top: 20px; */\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #8080804f;\n}\n\n.kyc_form_card_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.kyc_form_card_title {\n  color: #2d699b;\n  margin-bottom: 0px;\n  font-size: 2.2vh;\n}\n\n.kyc_form_card_blue_button {\n  background: #2d699b;\n  border: 1px solid #2d699b;\n  font-weight: 500;\n  color: #fff;\n  padding: 5px 10px;\n  font-size: 2vh;\n  border-radius: 0.375rem;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.kyc_form_card_blue_button:hover {\n  background: #2d6a9be3;\n}\n\n.kyc_form_wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: end;\n  gap: 15px;\n}\n\n.kyc_form_select_wrapper {\n  min-width: 100%;\n  width: 100%;\n  max-width: 100%;\n}\n\n.kyc_form_body_label {\n  color: #000000ba;\n  font-weight: 450;\n  font-size: 2vh;\n}\n\n.kyc_form_body_input {\n  border-color: hsl(0, 0%, 80%);\n  border-radius: 4px;\n  /* min-width: 250px;\n    width: 250px;\n    max-width: 250px; */\n}\n\n.kyc_form_card_footer {\n  margin-top: 10px;\n}\n\n.kyc_form_card_footer_p {\n  color: #cc0c0c;\n  font-size: 2vh;\n  margin-bottom: 5px;\n}\n\n.kyc_form_card_footer_content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.kyc_form_card_footer_content p {\n  color: #000;\n  margin-bottom: 0px;\n  font-size: 2vh;\n}\n.select_input_tag{\n  font-size: 2vh;\n}\n.kyc_form_card_delete_button {\n  background: #e11414eb;\n  border: 1px solid #e11414eb;\n  font-weight: 500;\n  color: #fff;\n  padding: 5px 5px;\n  border-radius: 0.375rem;\n  display: flex;\n  gap: 6px;\n  font-size: 14px;\n  align-items: center;\n  /* margin-top: 10px; */\n  /* min-height: 38px;\n  height: 38px;\n  max-height: 38px; */\n}\n\n.kyc_form_card_delete_button:hover {\n  background: rgba(255, 0, 0, 0.774);\n}\n\n.kyc_form_card_options {\n  margin-top: 15px;\n  /* border: 1px solid #8080804f;\n    padding: 5px;\n    border-radius: 3px; */\n}\n\n.kyc_form_card_options_p {\n  color: #d83d10;\n  margin-bottom: 0px;\n  font-weight: 500;\n  font-size: 2.2vh;\n}\n\n.kyc_form_card_options_header {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.kyc_form_card_options_add {\n  background: #d83d10;\n  border: none;\n  font-weight: 500;\n  color: #fff;\n  padding: 5px 16px;\n  border-radius: 0.375rem;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 2vh;\n}\n\n.kyc_form_card_options_add:hover {\n  background: #d83b10e3;\n  border: none;\n  font-weight: 500;\n  color: #fff;\n  padding: 5px 10px;\n  border-radius: 0.375rem;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.kyc_div_width {\n  min-width: 250px;\n  width: 250px;\n  max-width: 250px;\n}\n\n.kyc_ph_input .PhoneInput {\n  width: 100% !important;\n}\n\n.kyc_ph_input {\n  /* border-color: hsl(0, 0%, 80%); */\n  border-radius: 4px;\n  border: 1px solid hsl(0, 0%, 80%);\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  z-index: 0;\n}\n.kyc_ph_input .PhoneInput input {\n  border: none !important;\n  outline: none !important;\n  color: #000 !important;\n  font-weight: normal;\n  font-size: 2vh !important;\n}\n\n.kyc_div_width .css-1jqq78o-placeholder{\n  font-size: 2vh !important;\n  height: 30px !important;\n}\n\n.kyc_div_width .css-13cymwt-control{\n  height: 32px !important;\n}\n.select_input_tag__control{\n  height: 32px !important; \n}\n.css-t3ipsp-control{\n  min-height: 0px !important;\n}\n.kyc_div_width .css-1nmdiq5-menu{\n  min-height: 0px !important;\n}\n\n.css-13cymwt-control{\n  min-height: 0 !important;\n}\n .css-1wy0on6{\n  height: 30px !important;\n}\n.css-1dimb5e-singleValue{\n  font-size: 2vh !important;\n}\n.PhoneInputCountryIcon {\n  color: #000 !important;\n}\n\n/* media */\n\n@media (min-width: 400px) {\n  .kyc_form_select_wrapper {\n    min-width: 250px;\n    width: 250px;\n    max-width: 250px;\n  }\n\n  .kyc_form_body_input {\n    min-width: 250px;\n    width: 250px;\n    max-width: 250px;\n  }\n}\n\n/* end of hariharan css */\n\n/* start sakthi css 09-08-24 */\n\n.gap_zero {\n  gap: 0px;\n}\n.man_grp_sng_gap {\n  gap: 7px !important;\n}\n.mid_frm_lft {\n  margin-left: 19px;\n}\n.four_frm_lft {\n  margin-left: 7px;\n}\n.egt_frm_lft {\n  margin-left: 42px;\n}\n.lnc_frm_lft {\n  margin-left: 48px;\n}\n.frpm_frm_lft {\n  margin-left: 36px;\n}\n.egtpm_frm_lft {\n  margin-left: 47px;\n}\n\n.adm_inpt_wrp {\n  border: 1px solid rgba(34, 34, 34, 0.32);\n  height: 40px;\n  border-radius: 10px;\n}\n.adm_inpt_wrp input {\n  border: none;\n  outline: none;\n  background: none;\n  padding: 0px !important;\n  min-width: 100% !important;\n  width: 100% !important;\n  max-width: 100% !important;\n}\n.adm_inpt_wrp i {\n  cursor: pointer;\n}\n\n.mangra_overflow_align {\n  width: 100%;\n  /* overflow-x: auto; */\n  margin-top: 20px;\n  padding-bottom: 20px;\n  color: #2d699b;\n}\n.mangra_whole_ttl {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #232222;\n  margin-bottom: 20px;\n}\n.manualgra_xaxis_txt {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 25px;\n}\n.manualgra_xaxis_txt {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n}\n.manual_graph_single {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 3px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n.manual_graph_single .single_square {\n  height: 20px;\n  width: 12px;\n  min-width: 12px;\n  background-color: lightgrey;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.manual_graph_single .single_square .timing_div {\n  width: 25%;\n  background-color: #2d699b;\n  height: 20px;\n  max-height: 20px;\n}\n.manual_graph_single .single_square .test111 {\n  width: 25%;\n  background-color: lightgrey !important;\n  height: 20px;\n  max-height: 20px;\n}\n.manualgra_yaxis_txt {\n  margin: 0;\n  font-size: 13px;\n  color: #2d699b;\n  font-weight: 700;\n  margin-right: 10px;\n  min-width: 30px;\n}\n.cmn_ttl_aligns {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  gap: 20px;\n}\n.cmn_ttl_aligns_new.cmn_ttl_aligns {\n  justify-content: flex-start !important;\n}\n.title_percent_ttl {\n  width: 45%;\n}\n.title_percent_ttl_new.title_percent_ttl {\n  min-width: 250px;\n}\n.checkbox_title,\n.daysslct_ttl p {\n  margin: 0;\n  font-weight: 500;\n  font-size: 17px;\n}\n.whole_check_datepick {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 15px;\n  margin-top: 5px;\n  padding-bottom: 10px;\n}\n.daysslct_ttl {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 15px;\n}\n.show_days_div {\n  display: flex;\n  justify-content: flex-start;\n  gap: 9px;\n  align-items: center;\n  width: 40%;\n  font-weight: 700;\n  font-size: 18px;\n  min-width: 17px;\n  max-width: 17px;\n  margin-bottom: 0px;\n  margin-right: 15px;\n}\n\n.show_days_div .form-check {\n  margin-top: 0px;\n}\n.dateselect_dtls .rdt {\n  position: relative !important;\n}\n.dateselect_dtls .rdt input {\n  width: 100px;\n  height: 30px;\n}\n.dateselect_dtls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n}\n.dateselect_dtls .rdt input {\n  font-size: 11px;\n  padding: 5px 2px;\n}\n.dateselect_dtls .rdtPicker {\n  width: 140px;\n}\n.rdtOpen .rdtPicker {\n  width: 140px;\n  min-width: 140px;\n}\n.days_new_widh p {\n  width: 100px;\n}\n.days_new_widh p:last-child {\n  width: 27px !important;\n}\n.hider_txt {\n  opacity: 0;\n}\n.day_width_45 {\n  display: flex;\n  align-items: center;\n  /* justify-content: space-between; */\n  justify-content: flex-start;\n\n  min-width: 45%;\n}\n.linecheck_aligned {\n  display: flex;\n  justify-content: flex-start;\n  gap: 9px;\n  align-items: center;\n  width: 40%;\n}\n.linecheck_aligned.linecheck_aligned_new {\n  max-width: 17px;\n  margin-right: 15px;\n}\n\n.show_days_div .form-check-input.is-valid,\n.was-validated .form-check-input:valid {\n  /* border: 2px solid #6c6a81 !important; */\n  height: 16px;\n  width: 16px;\n}\n\n.show_days_div .form-check-input.is-valid,\n.was-validated .form-check-input:valid:active {\n  box-shadow: none !important;\n}\n\n.show_days_div input[type=\"checkbox\" i]:focus-visible {\n  outline-offset: 0px !important;\n}\n.show_days_div .form-check-input:active,\n.show_days_div .form-check-input:focus-visible {\n  /* filter: brightness(100%) !important; */\n  /* border: 2px solid #a71d24 !important; */\n}\n.show_days_div .form-check-input.is-valid:checked,\n.was-validated .form-check-input:valid:checked {\n  /* background-color: #fff; */\n  /* border: 2px solid #a71d24 !important; */\n}\n.show_days_div .form-check-input:checked[type=\"checkbox\"] {\n  /* background: url(\"../images/redtick.png\"); */\n  /* background-position: center; */\n  /* background-size: contain; */\n  /* background-repeat: no-repeat; */\n}\n.show_days_div .form-check-label {\n  color: #232222 !important;\n  font-size: 13px;\n  margin: 0;\n  font-weight: 500;\n}\n.order_trashed_ic {\n  height: 27px;\n  cursor: pointer;\n}\n.triple_copybtns {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n}\n.mangra_addtime.blue_btn {\n  width: 100px;\n  margin-top: 20px;\n  padding: 5px;\n}\n.mangra_addtime.mangra_addtime_new.blue_btn {\n  width: unset;\n  margin-top: 20px;\n  padding: 5px 20px;\n  margin-right: 15px;\n  white-space: nowrap;\n}\n\n.custom_label {\n  color: #2d699b;\n  font-weight: 500;\n}\n\n.from_to_timePick {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 15px;\n}\n\n.from_to_timePick.times {\n  gap: 85px;\n}\n\n.customDatePicker .rdt input {\n  font-size: 11px;\n  padding: 5px 10px;\n  width: 100px;\n  height: 30px;\n  border: 0.5px solid #2322224d;\n  background: linear-gradient(0deg, #ffffff, #ffffff),\n    linear-gradient(0deg, rgba(35, 34, 34, 0.3), rgba(35, 34, 34, 0.3));\n  border-radius: 10px;\n}\n\n.edit_admin .form-check {\n  border: none !important;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n.edit_admin .form-check-input {\n  margin-top: 0px;\n  height: 16px;\n  width: 16px;\n}\n\n.edit_admin .form-check .form-check-label {\n  display: inline;\n  line-height: 0px;\n  padding-left: 0.625rem;\n  font-size: 0.875rem;\n}\n\n/* .profile_details .upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n}\n\n.profile_details .upload-btn-wrapper .btn {\n  border: 1px solid gray;\n  color: #000000de;\n  background-color: white;\n  padding: 5px 15px;\n  border-radius: 4px;\n  font-size: 10px;\n}\n\n.moduleTitle-txt {\n  color: var(--themecolor);\n}\n\n.profile_details .upload-btn-wrapper input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n} */\n\n.profile_details .profileImg {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.profile_details .uploadImg {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.UserProfile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.UserProfile .profileImg {\n  width: 30px;\n  height: 30px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.card .card-title {\n  color: #2d699b !important;\n  font-size: 2vh;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .mangra_addtime.mangra_addtime_new.blue_btn {\n    margin-right: 6px !important;\n  }\n}\n@media (width < 992px) {\n  .mangra_overflow_align.mangra_overflow_align_new {\n    overflow-x: auto;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .tet_lefvc.checkbox_title.text-center.checkbox_title_new {\n    text-align: center !important;\n  }\n}\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .mangra_addtime.mangra_addtime_new.blue_btn {\n    margin-right: 6px !important;\n  }\n}\n@media (width < 576px) {\n  .mangra_overflow_align {\n    overflow-x: auto;\n  }\n  .title_percent_ttl {\n    width: 100%;\n  }\n  .checkbox_title {\n    min-width: 200px;\n  }\n  .checkbox_title_new.checkbox_title {\n    min-width: 300px !important;\n    /* text-align: center; */\n  }\n  .daysslct_ttl {\n    min-width: 200px;\n  }\n  .day_width_45 {\n    min-width: 200px !important;\n  }\n  .linecheck_aligned {\n    min-width: 200px;\n  }\n  .linecheck_aligned_new.linecheck_aligned {\n    min-width: unset !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .show_days_div {\n    margin-right: 0px;\n  }\n}\n\n@media (max-width: 767px) {\n  .title_percent_ttl {\n    width: 100% !important;\n  }\n}\n\n/* new changes sakthi end 12-11-24 */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
